import { inject } from 'vue';

export const useEmitter = () => {
  const emitter = inject('Emitter');

  if (!emitter) throw new Error('Emitter is not provided');

  return emitter;
};
